import thunk from "redux-thunk"

const middleware = [thunk]

export default middleware
